import * as React from 'react';
import { Checkbox, UIText2 } from '@cian/ui-kit';

import { NBSP } from '../../../../../../constants/symbols';

import * as styles from './SinglePackage.css';

interface IProps {
  label: string;
  checked: boolean;
  handleChange(): void;
}

export const SinglePackage = ({ label, checked, handleChange }: IProps) => {
  return (
    <div className={styles['wrapper']}>
      <Checkbox checked={checked} onChange={handleChange} />
      <div className={styles['label']} onClick={handleChange}>
        <UIText2 display="inline-block">Разместить из пакета{NBSP}</UIText2>
        <UIText2 color="gray60_100" display="inline-block">
          {label}
        </UIText2>
      </div>
    </div>
  );
};
